import React, { useState } from 'react';
import './VacanciesItemForm.scss';
import MyButton from '../../../UI/MyButton/MyButton';
import { url } from '../../../Modules/url/url';

const VacanciesItemForm = ({ vacancyTitle }) => {
  const [formData, setFormData] = useState({
    name: '',
    surname: '',
    phone: '',
    email: '',
    city: '',
    resumeLink: '',
    letter: ''
  });

  const [file, setFile] = useState(null);
  const [fileName, setFileName] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [isError, setIsError] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    setFile(selectedFile);
    setFileName(selectedFile ? selectedFile.name : '');
  };

  const handleSubmit = () => {
    setShowModal(true);
    setIsLoading(true);
    setIsSuccess(false);
    setIsError(false);

    const formPayload = new FormData();
    formPayload.append('name', formData.name);
    formPayload.append('surname', formData.surname);
    formPayload.append('phone', formData.phone);
    formPayload.append('email', formData.email);
    formPayload.append('city', formData.city);
    formPayload.append('resumeLink', formData.resumeLink);
    formPayload.append('letter', formData.letter);
    formPayload.append('vacancyTitle', vacancyTitle);

    if (file) {
      formPayload.append('file', file);
    }

    fetch(`${url}apply/`, {
      method: 'POST',
      body: formPayload,
    })
      .then((response) => {
        if (!response.ok) throw new Error('Network error');
        return response.json();
      })
      .then((data) => {
        console.log('Success:', data);
        setIsSuccess(true);
        setFormData({
          name: '',
          surname: '',
          phone: '',
          email: '',
          city: '',
          resumeLink: '',
          letter: ''
        });
        setFile(null);
        setFileName('');
      })
      .catch((error) => {
        console.error('Error:', error);
        setIsError(true);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  return (
    <div className='vacanciesItemForm_container'>
      <div className="vacanciesItemForm_block">
        <div className="vacanciesItemForm">
          <div className="vacanciesItemForm_title">
            <h1>Отклик на вакансию</h1>
            <p>{vacancyTitle}</p>
          </div>
          <div className="vacanciesItemForm_item">
            <form onSubmit={(e) => e.preventDefault()}>
              <div className="vacanciesItemFormInput_block">
                <div className="vacanciesItemFormInput_item">
                  <p>Имя</p>
                  <input type="text" name="name" value={formData.name} onChange={handleInputChange} />
                </div>
                <div className="vacanciesItemFormInput_item">
                  <p>Фамилия</p>
                  <input type="text" name="surname" value={formData.surname} onChange={handleInputChange} />
                </div>
              </div>
              <div className="vacanciesItemFormInput_block">
                <div className="vacanciesItemFormInput_item">
                  <p>Телефон</p>
                  <input type="number" name="phone" value={formData.phone} onChange={handleInputChange} />
                </div>
                <div className="vacanciesItemFormInput_item">
                  <p>Почта</p>
                  <input type="email" name="email" value={formData.email} onChange={handleInputChange} />
                </div>
              </div>
              <div className="vacanciesItemFormInputHref_block">
                <h4>Город</h4>
                <input type="text" name="city" value={formData.city} onChange={handleInputChange} />
              </div>
              <div className="vacanciesItemFormInputHref_block">
                <h4>Ссылка на резюме <span>Необязательно</span></h4>
                <input type="text" name="resumeLink" value={formData.resumeLink} onChange={handleInputChange} />
              </div>
              <h6>или</h6>
              <div className="vacanciesItemFormFile_block">
                <div className="vacanciesItemFormFile_item">
                  <div className="vacanciesItemFormFile">
                    <input type="file" onChange={handleFileChange} />
                    <p>
                      {fileName ? fileName : 'Выберите файл'}{' '}
                      <span>{!fileName && 'или переместите резюме сюда'}</span>
                    </p>
                  </div>
                </div>
                <h5>Форматы файла: DOC, DOCX, PDF. Не более 5 МБ</h5>
              </div>
              <div className="vacanciesItemFormCommet_block">
                <div className="vacanciesItemFormCommet_item">
                  <h4>Сопроводительное письмо</h4>
                  <p>Необязательно</p>
                </div>
                <textarea name="letter" value={formData.letter} onChange={handleInputChange} />
              </div>
              <h2>Я соглашаюсь<span> на обработку моих персональных данных</span></h2>
              <div className="vacanciesItemForm_btn">
                <MyButton
                  type="submit"
                  name="Отправить отклик"
                  width="250px"
                  height="40px"
                  onClick={handleSubmit}
                />
              </div>
            </form>
          </div>
        </div>
      </div>

      {/* Modal with loader and result */}
      {showModal && (
        <div className="vacanciesItemForm_modalOverlay">
          <div className="vacanciesItemForm_modal">
            {isLoading && (
              <div className="loaderContainer">
                <div className="loader"></div>
                <p>Отправка данных...</p>
              </div>
            )}
            {!isLoading && isSuccess && (
              <>
                <h2>Спасибо за отклик!</h2>
                <p>Мы свяжемся с вами в ближайшее время.</p>
                <button onClick={() => setShowModal(false)}>Закрыть</button>
              </>
            )}
            {!isLoading && isError && (
              <>
                <h2>Произошла ошибка</h2>
                <p>Пожалуйста, попробуйте позже.</p>
                <button onClick={() => setShowModal(false)}>Закрыть</button>
              </>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default VacanciesItemForm;
